import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React, { useEffect, useRef, useState } from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { arrayOf, node, oneOfType } from 'prop-types';
import styles from '../Select.css';
import { selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var SingleValue = function SingleValue(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _props$selectProps = props.selectProps,
      ellipsis = _props$selectProps.ellipsis,
      isMobile = _props$selectProps.isMobile,
      classes = _props$selectProps.classes,
      autoFieldHeight = _props$selectProps.autoFieldHeight;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCropped = _useState2[0],
      setIsCropped = _useState2[1];

  var valueRef = useRef();
  useEffect(function () {
    if (!isMobile && valueRef.current && valueRef.current.offsetWidth < valueRef.current.scrollWidth) {
      setIsCropped(true);
    } else if (isCropped) {
      setIsCropped(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [children]);
  return /*#__PURE__*/React.createElement(components.SingleValue, _extends({}, props, {
    innerProps: {
      ref: valueRef,
      title: isCropped ? children : undefined
    },
    className: cx('SingleValue', {
      ellipsis: ellipsis,
      autoFieldHeight: autoFieldHeight
    }, classes.singleValue)
  }), children);
};
SingleValue.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]).isRequired,
  selectProps: selectPropsPropTypes
} : {};